import {Button} from '@wandb/weave/components';
import React, {useCallback, useState} from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Modal} from 'semantic-ui-react';

export const ModalTriggerButton: React.FC<{
  modalHeader: string;
  modalContent: JSX.Element;
  buttonIcon: string;
  buttonText: string;
  onClick?: () => void;
}> = ({modalContent, modalHeader, buttonIcon, buttonText, onClick}) => {
  const [showModal, setShowModal] = useState(false);
  const openModal = useCallback(() => setShowModal(true), [setShowModal]);
  const closeModal = useCallback(() => setShowModal(false), [setShowModal]);

  return (
    <React.Fragment>
      {/* COLUMNS CONFIG */}
      <Modal
        className="small"
        trigger={
          <Button
            icon="column"
            variant="secondary"
            twWrapperStyles={{display: 'inline'}}
            onClick={() => {
              openModal();
              onClick?.();
            }}>
            {buttonText}
          </Button>
        }
        open={showModal}
        onClose={closeModal}>
        <Modal.Header>{modalHeader}</Modal.Header>
        <Modal.Content>{modalContent}</Modal.Content>
        <Modal.Actions>
          <Button onClick={closeModal}>Close</Button>
        </Modal.Actions>
      </Modal>
    </React.Fragment>
  );
};
